<template>
    <fragment>
        <li @click="setCoordinates">
            <v-icon left color="light-blue">train</v-icon>
            Náhled na trať
        </li>
    </fragment>
</template>
<script>
    export default {
        name: 'map-rail-images-context-menu',
        props: [
            'data',
        ],
        methods: {
            setCoordinates() {
                this.$store.dispatch('railImages/setUserCoordinates', this.data.coordinates);
            },
        },
    }
</script>
